module.exports = __webpack_public_path__ + "static/media/Emails.621e1d62.svg";